import { motion } from "framer-motion";
import { Waves, Users, Anchor } from "lucide-react";

const reveal = {
  initial: { y: 36, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, amount: 0.15 },
};

const CARDS = [
  {
    icon: Waves,
    bg: "bg-ocean-sky",
    title: "BIG HEART. BIGGER WAVES.",
    body: "The ocean was already massive. Then the biggest animal on earth showed up. Bluewhale has entered the meme game.",
    rotate: "-rotate-1",
  },
  {
    icon: Users,
    bg: "bg-ocean-yellow",
    title: "A LOUD COMMUNITY",
    body: "Community-driven. Meme-first. The pod makes the noise, rides the waves and welcomes everyone joining early.",
    rotate: "rotate-1",
  },
  {
    icon: Anchor,
    bg: "bg-ocean-coral",
    title: "BUILT FOR THE POD",
    body: "No complicated roadmap. No unnecessary promises. Just $BLUE and the pod behind it. That's the whole plan.",
    rotate: "-rotate-1",
  },
];

export default function Narrative() {
  return (
    <section id="story" data-testid="narrative-section" className="relative bg-ocean-bg2 py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-[1.2fr_0.8fr]">
          <motion.div {...reveal}>
            <p className="text-xs font-extrabold uppercase tracking-[0.3em] text-ocean-cyan">
              The Narrative
            </p>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.15] tracking-tight sm:text-5xl">
              The ocean was already massive. Then the biggest animal on earth{' '}
              <span className="marker-underline whitespace-nowrap">showed up.</span>
            </h2>
            <p className="mt-6 max-w-xl text-base font-medium leading-relaxed text-ocean-muted sm:text-lg">
              Join the pod. Make some noise. Ride the waves.{" "}
              <span className="font-bold text-ocean-navy">
                $BLUE — Big waves. Bigger community.
              </span>
            </p>
          </motion.div>

          <motion.div {...reveal} className="relative mx-auto w-56 sm:w-72">
            <motion.img
              data-testid="narrative-pod-img"
              src="/pod_whales.png"
              alt="The whale pod"
              className="animate-floaty w-full"
              draggable="false"
            />
            <span className="sticker-sm absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-white px-4 py-1.5 font-display text-sm font-semibold">
              the pod
            </span>
          </motion.div>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              data-testid={`narrative-card-${i}`}
              {...reveal}
              transition={{ ...reveal, delay: i * 0.12 }}
              className={`sticker ${c.bg} ${c.rotate} rounded-3xl p-7 transition-transform duration-300 hover:rotate-0 hover:-translate-y-2`}
            >
              <div className="sticker-sm inline-flex rounded-2xl bg-white p-3">
                <c.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-display text-2xl font-semibold leading-tight">
                {c.title}
              </h3>
              <p className="mt-3 text-sm font-medium leading-relaxed text-ocean-navy/80 sm:text-base">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
